import React, { useEffect, useState } from "react";
const currentTabStyleObj = {
    backgroundColor: '#274594',
    color: '#fff',
    cursor: 'pointer',
}
const filledTabStyleObj = {
    backgroundColor: '#4F9433',
    color: '#fff',
    cursor: 'pointer',
}
const unfilledTabStyleObj = {
    backgroundColor: '#D0D0D1',
    color: '#444444',
    cursor: 'not-allowed',
}

function OnboardingStepColumn(props) {
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        setCurrentStep(props?.currentFormStep);
    }, [props?.currentFormStep]);

    const onColumnClk = (ele, idx, data) => {
        if (data.disable == true) {
            return;
        }
        props.onColumnClk(ele, idx);
    }

    const setStepObj = (idx) => {
        let obj = {};
        if (props?.vendorDetails?.currentStep > 3) {
            if (currentStep == (idx + 1)) {
                obj.disable = false;
                obj.currentStep = true;
            }
            else {
                obj.disable = false;
                obj.currentStep = false;
            }
        }
        else {
            if (currentStep == (idx + 1)) {
                obj.disable = false;
                obj.currentStep = true;
            }
            else if (currentStep > (idx + 1)) {
                obj.disable = false;
                obj.currentStep = false;
            }
            else if (currentStep < (idx + 1)) {
                obj.disable = true;
                obj.currentStep = false;
            }
        }
        return obj;
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    {props?.formStepDetails?.form?.steps.map((ele, i) => <>
                        {(props?.formStepDetails?.form?.onboardingStepsCount > i) && <div className="col-sm-4 h-100">
                            <div className="step_num">Step {i + 1}</div>

                            <div className="first_bx " onClick={() => onColumnClk(ele, i, setStepObj(i))} >
                                <div className="step-column-div" style={(setStepObj(i)?.currentStep) ? currentTabStyleObj : (setStepObj(i)?.disable) ? unfilledTabStyleObj : filledTabStyleObj}> {ele?.stepName} </div>
                            </div>
                        </div>}
                    </>)}


                    {/* <div className="step_1">
                        <div className="step_num">Step 2</div>

                        <div className="gray_bx">
                            <a href="financial_tax_operational_information.html">
                            Financial, Tax, and Operational Information
                            </a>
                        </div>
                    </div>

                    <div className="step_1">
                        <div className="step_num">Step 3</div>

                        <div className="gray_bx">
                            <a href="technical_compliance_quality.html">
                            Technical, Compliance, and Quality Assurance
                            Documentation
                            </a>
                        </div>
                    </div> */}

                </div>
            </div>
        </div>
    );
}

export default OnboardingStepColumn;
